import { Button, ErrorState } from "@wirevod/ui";
import { isRouteErrorResponse, Link, useRouteError } from "react-router";
import styles from "./errors.module.css";

export function NotFoundPage() {
  return (
    <div className={styles.page}>
      <p className={styles.code}>404</p>
      <h1 className={styles.title}>This page doesn&apos;t exist</h1>
      <p className={styles.text}>The link may be out of date, or the item was deleted.</p>
      <Link to="/" className={styles.link}>
        Back to the start
      </Link>
    </div>
  );
}

/** Route error boundary: a failed chunk load or an unexpected render error. */
export function RouteError() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  const chunkFailed =
    error instanceof Error &&
    /dynamically imported module|Importing a module script/i.test(error.message);
  return (
    <div className={styles.page}>
      <ErrorState
        title={chunkFailed ? "A new version is available" : "Something went wrong"}
        message={
          chunkFailed
            ? "WireVoD was updated while this page was open. Reload to continue."
            : "This page couldn't be displayed. Reloading usually fixes it; if not, contact support@wirevod.online."
        }
        onRetry={() => window.location.reload()}
        retryLabel="Reload"
      />
      {!chunkFailed ? (
        <Button variant="ghost" onClick={() => window.location.assign("/")}>
          Go to the start
        </Button>
      ) : null}
    </div>
  );
}
